import React, { forwardRef, useContext } from "react";

// plugin
import { motion } from "motion/react";
import { StaticImage } from "gatsby-plugin-image";
import {
	// Link,
	Trans,
	useTranslation,
} from "@herob191/gatsby-plugin-react-i18next";

// style
import "./menuBody.scss";

// context
import { LayoutContext } from "../../../../context/layoutContext";

// component
import FlashHover from "../../../flashHover/flashHover";
import ContactScript from "../../../contactScript/contactScript";

// util

// svg

// component
const MenuBody = forwardRef(function MenuBody(props, ref) {
	const { t } = useTranslation();
	const { menuOpen, setMenuOpen } = useContext(LayoutContext);

	const closeMenu = () => {
		setMenuOpen(false);
	};

	return (
		<motion.div
			ref={ref}
			className="menuBodyWrapper"
			initial={{ opacity: 0 }}
			animate={{ opacity: menuOpen ? 1 : 0 }}
			exit={{ opacity: 0 }}
		>
			<div className="menuBody">
				<div className="ganchilloContact">
					<StaticImage
						src="../../../../images/ganchillo/1.png"
						alt={t("Un mantel de ganchillo")}
						class="ganchilloBg"
						loading="eager"
					/>
					<ContactScript />
				</div>

				{/* <FlashHover>
					<Link to="/telita" className="borderButton" onClick={closeMenu}>
						<Trans>Quiénes somos</Trans>
					</Link>
				</FlashHover> */}

				<FlashHover>
					<button className="underline p2" onClick={closeMenu}>
						<Trans>Cerrar y volver a proyectos</Trans>
					</button>
				</FlashHover>
			</div>
		</motion.div>
	);
});

export default MenuBody;
